import { defineComponent as b, computed as y, useCssModule as g, openBlock as o, createElementBlock as a, normalizeClass as e, createElementVNode as i, renderSlot as r, createCommentVNode as l } from "vue";
import h from "../../utils/propValidator.mjs";
import $ from "./styles/CdrBanner.module.scss.mjs";
import C from "../../../_virtual/_plugin-vue_export-helper.mjs";
const v = b({
  name: "CdrBanner",
  props: {
    /**
     * Sets the banner style.
     * @demoSelectMultiple false
     * @values info, warning, success, error, default
    */
    type: {
      type: String,
      validator: (s) => h(s, ["info", "warning", "success", "error", "default"]),
      default: "default"
    }
  },
  setup(s, n) {
    const t = "cdr-banner", d = y(() => `${t}--${s.type}`), c = y(() => n.slots["message-body"] ? `${t}__wrapper--prominence` : void 0), p = n.slots["icon-left"], f = n.slots["icon-right"], m = n.slots["message-body"], u = n.slots["info-action"];
    return {
      style: g(),
      baseClass: t,
      typeClass: d,
      prominenceClass: c,
      hasIconLeft: p,
      hasIconRight: f,
      hasMessageBody: m,
      hasInfoAction: u
    };
  }
});
function k(s, n, t, d, c, p) {
  return o(), a("div", {
    class: e([s.style[s.baseClass], s.style[s.typeClass]])
  }, [i("div", {
    class: e([s.style["cdr-banner__wrapper"], s.style[s.prominenceClass]])
  }, [i("div", {
    class: e([s.style["cdr-banner__main"]])
  }, [s.hasIconLeft ? (o(), a("div", {
    key: 0,
    class: e([s.style["cdr-banner__icon-left"]])
  }, [r(s.$slots, "icon-left")], 2)) : l("", !0), i("span", {
    class: e([s.style["cdr-banner__message"]])
  }, [r(s.$slots, "default")], 2), s.hasIconRight ? (o(), a("div", {
    key: 1,
    class: e([s.style["cdr-banner__icon-right"]])
  }, [r(s.$slots, "icon-right")], 2)) : l("", !0)], 2), s.hasMessageBody ? (o(), a("div", {
    key: 0,
    class: e([s.style["cdr-banner__message-body"]])
  }, [r(s.$slots, "message-body")], 2)) : l("", !0)], 2), s.hasInfoAction ? (o(), a("div", {
    key: 0,
    class: e([s.style["cdr-banner__info-action"]])
  }, [r(s.$slots, "info-action")], 2)) : l("", !0)], 2);
}
const B = {
  $style: $
}, A = /* @__PURE__ */ C(v, [["render", k], ["__cssModules", B]]);
export {
  A as default
};
